/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/prop-types */
import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import BackButton from "../../../assets/Vector/BackButton.svg";

const MainContainer = styled.div`
  display: flex;
  padding: 16px 10px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
  // margin: 0 24px;
  margin: 24px 24px 0px 24px;
`;
const Text = styled.p`
  color: #4c4e8d;
  font-family: Noto Sans;
  font-size: 18px;
  font-weight: 500;
  margin: 0 0;
`;
function Heading({ title }) {
  const navigate = useNavigate();
  const handleBack = () => {
    navigate(-1);
  };
  return (
    // <div>Heading</div>
    <MainContainer>
      <img
        src={BackButton}
        alt="/backbutton"
        onClick={handleBack}
        style={{ cursor: "pointer" }}
      />
      <Text>{title}</Text>
    </MainContainer>
  );
}

export default Heading;
